import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_89: FaireProductEntity = {
  token: "legacy_prod_abbott-89",
  type: "product",
  name: "Large Velvet Pouch with 3D Leopard, Navy Blue 5×7 L",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/4af3817d929aa8c536025f6ea84ca19e64e8206a361a815316b7477a04a9ac9f.jpeg",
  priceDollars: 16,
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_womens-accessories"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
